import { render } from "./TabPreparations.vue?vue&type=template&id=ac2890fc"
import script from "./TabPreparations.vue?vue&type=script&lang=js"
export * from "./TabPreparations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__